module.exports = __webpack_public_path__ + "img/feedback_caution_manual.9336c65f.svg";